import React from 'react';
import Cookies from 'js-cookie';

import ReactDOM from 'react-dom';

import authApi from '../api/auth.jsx';

import sessionService from '../services/sessionService.jsx';

import events from '../lib/events.js';

const insufficientPrivileges =
  <div className='container nav-tabs'>
    <div className='row'>
      <div className='col-sm-12'>
        <h2>Insufficient Privileges</h2>
        <p> You have insufficient privileges to view this page </p>
      </div>
    </div>
  </div>

;

const requireAuthLevel = (authLevel, onSuccess)  => {
  return (container, params) => {
    if (sessionService.isSignedIn()) {
      if (!authLevel || sessionService.getUser()[authLevel]) {
        onSuccess(container, params);
      } else {
        ReactDOM.render(insufficientPrivileges, container);
      }
    } else {
      // Force user to be logged in
      authApi.getCurrentUser()
        .then(user => {
          try {
            sessionService.setUser(user);
            if (!authLevel || sessionService.getUser()[authLevel]) {
              onSuccess(container, params);
            } else {
              ReactDOM.render(insufficientPrivileges, container);
            }
          } catch (error) {
            console.error(error);
            events.publish('error.user', error);
          }
        })
        .catch(() => {
          if (window.location.hash && window.location.hash !== 'signIn' && window.location.hash !== '#signIn') {
            console.log('Setting failed login redirect link to: ' + window.location.hash);
            Cookies.set('failed-login-attempted-page', window.location.hash, {expires: 1 / 144}); // Expires in 10 minutes
          }
          window.location.hash = '#signIn';
        });
    }
  };
};

export default {
  requireAuth: requireAuthLevel.bind(null, null),
  requireAdmin: requireAuthLevel.bind(null, 'isAdmin'),
};
